/**
 * Story synopsis modal startup and button wiring.
 */
export function initStoryModal(options = {}, documentRef = document) {
  const storyModal = documentRef.getElementById('storySynopsisModal')
  const closeSynopsisBtn = documentRef.getElementById('closeSynopsisBtn')
  const showSynopsisBtn = documentRef.getElementById('showSynopsisBtn')
  const readOnboardingState = options.readOnboardingState || (() => ({}))
  const writeOnboardingState = options.writeOnboardingState || (() => {})
  const startGuideTour = options.startGuideTour || (() => {})

  function showStoryModal() {
    if (storyModal) storyModal.style.display = 'flex'
  }

  function hideStoryModal() {
    if (storyModal) storyModal.style.display = 'none'
  }

  if (closeSynopsisBtn)
    closeSynopsisBtn.addEventListener('click', hideStoryModal)
  if (showSynopsisBtn) showSynopsisBtn.addEventListener('click', showStoryModal)

  const onboardingStateOnLoad = readOnboardingState()
  if (
    onboardingStateOnLoad.welcomeDismissed ||
    onboardingStateOnLoad.firstRunTourStarted
  ) {
    showStoryModal()
  } else {
    hideStoryModal()
    writeOnboardingState({
      welcomeDismissed: true,
      firstRunTourStarted: true,
    })
    window.setTimeout(() => startGuideTour('visualizationBasics'), 450)
  }

  return {
    hideStoryModal,
    showStoryModal,
  }
}
